export enum LoggedOutFilterType {
  Position = 'position',
  Employer = 'employer',
}
